module.exports = __webpack_public_path__ + "img/PLAY 1.1bde385a.png";